import axios from 'axios'
import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { login } from '../../../api/POST/login'
import { logout } from '../../../api/POST/logout'
import { setLoggedinUser, toggleCsrfState } from '../../../slices/authSlice'
import { setContactFilterType } from '../../../slices/contactAddressSlice'

declare global {
  // sessionExpirationDetected を redux authSlice に保持した場合、useMutateContactAddress での更新更新をuseMutateAuthで検出できないため、globalに保持する
  var sessionExpirationDetected: boolean;   // セッションタイムアウトフラグ
}

export const useMutateAuth = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const loginMutation = useMutation(login, {
    onSuccess: (response) => {
      global.sessionExpirationDetected = false;   // セッションタイムアウトフラグをクリア
      const { id, username, role, contactId, userId, companyName } = response.data
      dispatch(
        setLoggedinUser({
          id,
          username,
          role,
          contactId,
          userId,
          companyName,
        }),
      )
      dispatch(setContactFilterType((role !== 4 ? 'all' : 'personal')))
      navigate('/contactAddress')
    },
    onError: (err: any) => {
      alert(`ログインに失敗しました`)
      if (err.response.data.detail === 'The CSRF token has expired.') {
        dispatch(toggleCsrfState())
      }
    },
  })

  const logoutMutation = useMutation(logout, {
    onSuccess: () => {
      delete axios.defaults.headers.common['X-CSRF-Token']
      dispatch(
        setLoggedinUser({
          id: Infinity,
          username: '',
          role: Infinity,
        }),
      )

      navigate('/login')
    },
    onError: () => {
      dispatch(toggleCsrfState())
      navigate('/login')
    },
  })

  return { loginMutation, logoutMutation }
}
